import isEqual from 'lodash.isequal'
import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  properties: [],
  propertiesGeo: {},
  count: null,
  suggestions: [],
  searching: false,
  searchBoxText: '',
  itemsView: 'photos',
  mapView: true,
  listing: '',
  selectedProperties: [],
  suggestedParcels: [],
  homePageSearchMode: 'Quick',
  region: '',
  propertyStatuses: null,
  dwellingTypes: null,
  dateAvailable: null,
  furnishedRentals: null,
  counties: null,
  cities: null,
  zipCodes: null,
  houseSquareFeet: null,
  lotSquareFeet: null,
  daysSinceListed: null,
  prices: null,
  propertyHighlight: null,
  regionFiltersVisible: true,
  buyerFinancing: null,
  cooling: null,
  diningArea: null,
  elementarySchool: null,
  elementarySchoolDistrict: null,
  heating: null,
  highSchool: null,
  highSchoolDistrict: null,
  middleOrJuniorSchool: null,
  nonAssistivePets: null,
  otherRooms: null,
  solarPanelsOwnership: null,
  vacationRental: null,
  mapWidth: null,
  activeMoreTab: 'primary',
  moreTaxSectionsExpanded: ['Main'],
  morePrimaryRentalsExpanded: false,
  searchScrollPosition: null,
  parcelPropertyUseCode: null,
  floodZone: null,
  mcr: null,
  deedType: null,
  deedTransactionType: null,
  loanFinanceType: null,
  firstMortgageAmount: null,
  parcelLegalClass: null,
  parcelOwnerState: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PROPERTIES:
      return {
        ...state,
        properties: action.properties,
        count: action.count
      }
    case actionTypes.SET_PROPERTIES_GEO:
      return {
        ...state,
        propertiesGeo: action.propertiesGeo
      }
    case actionTypes.CLEAR_PROPERTIES_GEO:
      return {
        ...state,
        propertiesGeo: {}
      }
    case actionTypes.SET_ITEMS_VIEW:
      return {
        ...state,
        itemsView: action.itemsView
      }
    case actionTypes.TOGGLE_MAP:
      return {
        ...state,
        mapView: !state.mapView
      }
    case actionTypes.SET_USER_VIEW_SEARCH_PREFERENCES:
      return {
        ...state,
        ...action.obj
      }
    case actionTypes.SET_SEARCH_BOX_TEXT:
      return {
        ...state,
        searchBoxText: action.searchBoxText
      }
    case actionTypes.SET_SUGGESTIONS:
      return {
        ...state,
        suggestions: action.suggestions
      }
    case actionTypes.SET_PROPERTY_COMPS:
      return {
        ...state,
        comparedProperties: action.properties
      }
    case actionTypes.SET_SELECTED_PROPERTIES:
      return {
        ...state,
        selectedProperties: action.properties
      }
    case actionTypes.SET_SUGGESTED_PARCELS:
      return {
        ...state,
        suggestedParcels: action.docIds
      }
    case actionTypes.SET_PROPERTY_STATUSES:
      return {
        ...state,
        propertyStatuses: action.statuses
      }
    case actionTypes.SET_REGION_SEARCH:
      return {
        ...state,
        region: action.id
      }
    case actionTypes.CLEAR_PROPERTIES:
      return {
        ...state,
        properties: [],
        count: 0
      }
    case actionTypes.SET_HOME_PAGE_SEARCH_MODE:
      return {
        ...state,
        homePageSearchMode: action.mode
      }
    case actionTypes.SET_DWELLING_TYPES:
      return {
        ...state,
        dwellingTypes: action.dwellingTypes
      }
    case actionTypes.SET_COUNTIES:
      return {
        ...state,
        counties: action.counties
      }
    case actionTypes.SET_CITIES:
      return {
        ...state,
        cities: action.cities
      }
    case actionTypes.SET_ZIP_CODES:
      return {
        ...state,
        zipCodes: action.zipCodes
      }
    case actionTypes.SET_HOUSE_SQUARE_FEET:
      return {
        ...state,
        houseSquareFeet: action.houseSquareFeet
      }
    case actionTypes.SET_LOT_SQUARE_FEET:
      return {
        ...state,
        lotSquareFeet: action.lotSquareFeet
      }
    case actionTypes.SET_DAYS_SINCE_LISTED:
      return {
        ...state,
        daysSinceListed: action.daysSinceListed
      }
    case actionTypes.SET_PRICES:
      return {
        ...state,
        prices: action.prices
      }
    case actionTypes.SET_PROPERTY_HIGHLIGHT:
      return {
        ...state,
        propertyHighlight: action.markerId
      }
    case actionTypes.SET_REGION_FILTERS_VISIBLE:
      return {
        ...state,
        regionFiltersVisible: action.visible
      }
    case actionTypes.SET_SEARCHING:
      return {
        ...state,
        searching: action.searching
      }
    case actionTypes.REMOVE_ITEM_FROM_LIST:
      return {
        ...state,
        properties: state.properties.map(p => {
          if (isEqual(p.docId, action.docId)) {
            return {
              ...p,
              removed: true
            }
          }
          return p
        })
      }
    case actionTypes.ADD_ITEM_TO_SELECTED_LIST:
      return {
        ...state,
        properties: state.properties.map(p => {
          if (isEqual(p.docId, action.docId)) {
            return {
              ...p,
              removed: undefined
            }
          }
          return p
        })
      }
    case actionTypes.SET_SEARCH:
      return {
        ...state,
        ...action
      }
    case actionTypes.SET_MAP_WIDTH:
      return { ...state, mapWidth: action.width }
    case actionTypes.SET_ACTIVE_MORE_TAB:
      return { ...state, activeMoreTab: action.tab }
    case actionTypes.SET_MORE_PRIMARY_RENTALS_EXPANDED:
      return { ...state, morePrimaryRentalsExpanded: action.expanded }
    case actionTypes.SET_SCROLL_POSITION:
      return { ...state, searchScrollPosition: action.obj }
    case actionTypes.SET_EXPANDED_TAX_SECTIONS:
      return { ...state, moreTaxSectionsExpanded: action.sections }
    default:
      return state
  }
}

export default reducer
